/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Vue router shared path names
 */
export enum RouterPathName {
  Authenticate = "Authenticate",
  AppMain = "AppMain",
  FalconPaymentsView = "FalconPaymentsView",
  FalconDocumentsView = "FalconDocumentsView",
  FalconDocumentsWithDocumentDetails = "FalconDocumentsWithDocumentDetails",
  FalconComplaintsView = "FalconComplaintsView",
  FalconComplaintFirstStepForm = "FalconComplaintFirstStepForm",
  FalconComplaintSecondStepForm = "FalconComplaintSecondStepForm",
  FalconComplaintThirdStepForm = "FalconComplaintThirdStepForm",
  FalconComplaintSummary = "FalconComplaintSummary"
}
